import { Box, Text } from '@chakra-ui/react';

const ElementInstructions = ({ instructions }) => {
  if (typeof instructions === 'undefined') {
    return null;
  } else {
    return (
      <Box
        // pb={['12px', null, '16px']}
        maxW='98%'>
        <Text variant="instructions">
          {instructions}
        </Text>
      </Box>
    );
  }
};

export default ElementInstructions;
